import cls from 'classnames';
import style from './index.module.scss';
import { EnglishSpace, formatCentsToYuan } from '@/utils';
// import { isBuy } from './hooks';
import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { COUPON_TYPE } from '@/components/SeclectCoupon/const';
import { Currency } from '@/components/Currency';
import dayjs from '@/utils/timezone/dayjs';
import { useStore } from '@/store';
import { LANGUAGE } from '@/types';

const CouponItem = (props) => {
  const intl = useIntl();
  const { click, coupon, disable, select, rightIcon = '' } = props;
  const { baseObj } = useStore();
  const handleClick = () => {
    click && click();
  };
  // const buyed = isBuy(coupon);

  const jiage = useMemo(() => {
    const { couponType, discountValue } = coupon || {};
    if (couponType === COUPON_TYPE.DISCOUNT_COUPON) {
      if ([LANGUAGE.en, LANGUAGE['en-US']].includes(baseObj.currentLanguage)) {
        return `${100 - Number(discountValue)}% off`;
      } else {
        return `${Number(discountValue) / 10}折`;
      }
    }
    return (
      <span>
        <Currency />
        {formatCentsToYuan(discountValue)}
      </span>
    );
  }, [coupon]);

  const couponTypeTitle = useMemo(() => {
    const useTypeObj = {
      TICKET: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.ShadowTicket', defaultMessage: '影票' }),
      GOODS: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.SellingProducts', defaultMessage: '卖品' }),
      COMMON: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Universal', defaultMessage: '通用' }),
    };
    const couponTypeObj = {
      CASH_COUPON: intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.Voucher', defaultMessage: '代金券' }),
      EXCHANGE_VOUCHER: intl.formatMessage({
        id: 'iWeb.components.SeclectCoupon.ExchangeVoucher',
        defaultMessage: '兑换券',
      }),
      REPRICE_COUPON: intl.formatMessage({
        id: 'iWeb.components.SeclectCoupon.SpecialCoupon',
        defaultMessage: '特惠券',
      }),
      DISCOUNT_COUPON: intl.formatMessage({
        id: 'iWeb.components.SeclectCoupon.DiscountCoupons',
        defaultMessage: '折扣券',
      }),
      [COUPON_TYPE.ANY_VOUCHER]: intl.formatMessage({
        id: 'iWeb.components.CouponItem.CustomCoupon',
        defaultMessage: '自定义兑换券',
      }),
    };
    const couponType = coupon?.useType === 'COMMON' ? EnglishSpace(useTypeObj?.[coupon?.useType]) : useTypeObj?.[coupon?.useType];
    return couponType + EnglishSpace() + couponTypeObj?.[coupon?.couponType];
  }, [coupon]);
  const isBuy = useMemo(() => {
    /**
 * 备注: 优惠券发放来源
 * 1:    '营销系统'
 * 2:    '会员系统'
 * 4:    '批次发券'
 * 5:    '手动发券'
 * 7:    '券销售订单'
 * 8:    'POS重新发券'
 * 9:    '积分商城'
 * 10:   '预制券批次'
 * 12:   '大数据发券'
 * 13:   '商品化售卖'
 */
    const systemSourceValues = [9, 13];
    const { systemSource } = coupon;
    return systemSourceValues.includes(systemSource);
  }, [coupon]);

  const tips = useMemo(() => {
    const { couponType, useType, limitValue } = coupon || {};
    switch (couponType) {
      case 'EXCHANGE_VOUCHER':
      case COUPON_TYPE.ANY_VOUCHER:
        return intl.formatMessage({
          id: 'iWeb.components.SeclectCoupon.MaximumDeductionAmount',
          defaultMessage: '最高抵扣金額',
        });
      case 'CASH_COUPON':
        if (limitValue > 0) {
          return `满Mop${formatCentsToYuan(limitValue)}可用`;
        }

        return intl.formatMessage({
          id: 'iWeb.components.SeclectCoupon.NoConsumptionThreshold',
          defaultMessage: '无消费门槛',
        });
      case 'DISCOUNT_COUPON':
        if (useType === 'TICKET') return intl.formatMessage({
          id: 'iWeb.components.SeclectCoupon.DiscountTicketPurchase',
          defaultMessage: '折扣购票',
        });
        return intl.formatMessage({ id: 'iWeb.components.SeclectCoupon.DiscountPurchase', defaultMessage: '折扣購買' });
      case 'REPRICE_COUPON':
        if (useType === 'TICKET') return intl.formatMessage({
          id: 'iWeb.components.SeclectCoupon.DiscountTicketPurchase.1',
          defaultMessage: '優惠購票',
        });
        return intl.formatMessage({
          id: 'iWeb.components.SeclectCoupon.DiscountPurchase.1',
          defaultMessage: '優惠購買',
        });
      default:
        return '';
    }
  }, [coupon]);

  const getCouponTypeColor = useMemo(() => {
    switch (coupon.curCouponType || coupon.couponType) {
      case COUPON_TYPE.CASH_COUPON:
        return '#61b13a';
        break;
      case COUPON_TYPE.EXCHANGE_VOUCHER:
        return '#dc7e30';
        break;
      case COUPON_TYPE.REPRICE_COUPON:
        return '#345fb2';
        break;
      case COUPON_TYPE.DISCOUNT_COUPON:
        return '#dd8280';
        break;
      default:
        return '';
        break;
    }
  }, [coupon]);

  return (
    <div
      className={cls(style.panel_coupon_item, style[coupon.curCouponType || coupon.couponType], {
        [style.disable]: disable,
      })}
      style={{
        // @ts-ignore
        '--couponTypeColor': getCouponTypeColor,
      }}
      onClick={handleClick}
    >
      <div className={cls(style.couponStatus, {
        [style.used]: coupon?.state === 'USEED',
        [style.expired]: coupon?.state === 'EXPIRED',
      })}
      />
      <div className={style.couponItemContent}>
        <div className={cls(style.line, style[coupon.curCouponType || coupon.couponType])} />
        <div className={style.topContext}>
          <div className={style.couponTypeTitleLeft}> <div className={cls(style.couponType, style[coupon.curCouponType || coupon.couponType])}>{couponTypeTitle}</div>{isBuy && <>&nbsp;<span>购买</span></>}</div>
          {!disable && typeof rightIcon !== 'function' && (
            <div
              className={cls(style.round, {
                [style.select]: select,
              })}
            />
          )}
          {
            typeof rightIcon === 'function' && rightIcon?.()
          }
        </div>
        <div className={style.border} />
        <div className={style.couponContext}>
          <div className={style.price}>{jiage}</div>
          <div className={style.name}>
            {coupon.name}
          </div>
          <div className={style.tips}>{tips}</div>
          <div className={style.desk}>
            {coupon.usePolicyDesc || coupon.couponDesc}
          </div>
        </div>
        <div className={cls(style.border, style.solid)} />
        <div className={style.date}>
          <div>
            <span>{dayjs(coupon.startTime).tz().format('YYYY/MM/DD')}</span> <span>-</span>{' '}
            <span>{dayjs(coupon.expireTime).tz().format('YYYY/MM/DD')}</span>
          </div>
          {coupon.warning && <div>{coupon.warning}</div>}
        </div>
      </div>
    </div>
  );
};

export default CouponItem;
